import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import MainLayout from "../../../../components/layouts/MainLayout";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../components/layouts/TopContent";
import { taxGroupApi, taxGroupLabel, taxGroupStatic } from "./taxGroup.config";

import { rightAction } from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";
import appStatic from "../../../../config/appStatic";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { manageTaxGroupItems, monthList } = taxGroupStatic;

const columns = [
  {
    title: "Tax Group ID",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
];

const ManageTaxGroup = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const {
    userData,
    // onSelectItemAction,
    rightBtn,
    rightAction,
  } = props;
  const { session } = userData;
  const [taxGroupList, setTaxGroupList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rightViewBtn, setRightViewBtn] = useState("default");
  const dispatch = useDispatch();

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();
    // console.log(searchKey);

    if (!searchKey) {
      setTaxGroupList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name?.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    setTaxGroupList(filterBySearch);
  }
  function selectTableCount(value) {
    setTableCount(value);
  }
  //END METHODS DECLARED

  useEffect(() => {
    //DISABLE ALL RIGHTSIDEBAR ACTION
    BOM.HasPermission("READ_TAXGROUP") && getTaxGroup();
    BOM.HasPermission("CREATE_TAXGROUP") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getTaxGroup = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, taxGroupApi.taxGroup, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = BOM.GetUnique(res, "id");
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name,
          });
        });

        setTaxGroupList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, taxGroupApi.taxGroup, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = BOM.GetUnique(res, "id");
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              name: element?.name,
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-tax-group", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-tax-group", { state: { id: selectedRow.id } });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-tax-group", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_TAXGROUP") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_TAXGROUP") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      if (item)
        dispatch({
          type: item,
        });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onEdit={handleOnEdit}
      onAdd={handleOnCreate}
    >
      <TopContent pageTitle={taxGroupLabel.manageTaxGroups} pageItems={manageTaxGroupItems} />

      {/* RENDER TABLE LIST */}
      <Card
        title={"Tax Groups"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={taxGroupList}
              columns={columns}
              fileName={"Tax Group List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={taxGroupList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageTaxGroup);
